import axios from 'axios';
import { TrendsApiResponse, Trend, TrendDetailApiResponse } from '../interfaces';

export const fetchTrendsData = async (): Promise<TrendsApiResponse> => {
  const response = await axios.get<TrendsApiResponse>('https://api.diwo.capital/v1/trends');
  
  return {
    data: response.data.data,
    total: response.data.total,
    timestamp: response.data.timestamp
  };
};

export const fetchTrendDetail = async (id: number): Promise<Trend> => {
  const response = await axios.get<TrendDetailApiResponse>(`https://api.diwo.capital/v1/trends/${id}`);
  return response.data.data;
}; 